import { maintenanceTypes } from "../types/maintenanceTypes"
import { Dispatch } from 'redux';
import { GET, POST, PUT, DELETE } from '../../utils/axios';
import { mapBillToFormResponseToClient, maptoBillToTable } from "../../scenes/Maintenance/BillTo/components/commonFn"


export const getBillToData = (params: any) => {
    return async (dispatch: Dispatch) => {
        const res = await getBillToDataApiReq(params);
        dispatch(setMaintenance(res));
        return res;
    };
}

const setMaintenance = (apiData: any) => {
    return {
        type: maintenanceTypes.MAINTENANCE_DATA,
        payload: apiData,
    };
};


export const getBillToDataApiReq = async (params: any) => {
    console.log("params--sort--billto", params)
    // let url = `/shipperconsignee/${params.locationNumber}`
    let url = "/customers/list"

    let queryString = `?page=${params?.pageData?.page}&size=${params?.pageData?.pageSize}&sortBy=${params?.sortData?.field}&sortOrder=${params?.sortData?.sort}`;
    if (params?.search) {
        params.search = encodeURIComponent(params.search);
    }
    if (params?.billToStatus === "A" && params?.search) {
        queryString += `&billToStatus=A&search=${params?.search}`
    } else {
        if (params?.billToStatus === "A") {
            queryString += `&billToStatus=A`
        }
        if (params?.search) {
            queryString += `&search=${params?.search}`
            //  queryString  +=`&search=A&searchBy=status`
        }
    }

    try {
        let res = await GET(url + queryString);
        if (res && res.httpCode === 200 && res.status === 'success') {
            console.log("res.data", res)
            let data = { data: maptoBillToTable(res?.data?.data), count: res?.data?.totCount }
            console.log("----data", data)

            return data;
        }
        return [];

    } catch (err) {
        return [];
    }

}

export const getRulesApi = async () => {
    let url = "/rules/customers/delivery/headers";

    try {
        let res = await GET(url);

        if (res && res.httpCode === 200 && res.status === "success") {
            console.log("res--rules", res);

            const data = {
                data: res?.data?.data || res?.data || [],
                count: res?.data?.totCount || (res?.data?.data?.length ?? 0),
            };

            console.log("----rules data", data);

            return data;
        }

        return [];
    } catch (err) {
        console.error("Error in getRulesApi:", err);
        return [];
    }
};

export const getSingleBillToData = (req: any) => {
    return async (dispatch: Dispatch) => {
        const res = await singleBillToDataApiReq(req);
        dispatch(setMaintenance(res));
        return res;
    };
}

export const singleBillToDataApiReq = async (req: any) => {
    try {

        if (req.code) {

            let res = await GET(`/customers/code/${req.code}`)
            console.log("res", res)
            if (res && res.httpCode === 200 && res.status === 'success') {
                console.log("res.data", res)
                let data = mapBillToFormResponseToClient(res?.data);
                console.log("----data", data)

                return data;

            }

        } else {
            let data = mapBillToFormResponseToClient();
            console.log(">>>>>data", data)

            return data;

        }

    } catch (err) {
        return [];
    }
}

export const saveBillToContactData = (LocationNumber: any, params: any, code: any) => {
    return async (dispatch: Dispatch) => {
        const res = await saveBillToContactReq(LocationNumber, params, code);
        dispatch(setMaintenance(res));
        return res;
    }
}

export const saveBillToContactReq = async (locationNumber: number, params: any, code: any) => {
    console.log(">>>>postDAta", locationNumber, params, code)
    try {
        const url = `/contacts/customers/${code}/add/bulk`;
        const res = await POST(url, params);
        return res;
    } catch (err) {
        // Handle errors appropriately
        console.error("Error:", err);
        return [];
    }
}


export const saveBillToInvoiceReq = async (payload: any, code: any) => {
    console.log(">>>>postDAta", payload, code)
    try {
        const url = `/customers/${code}/doc-delivery-config`;
        const res = await POST(url, payload);
        return res;
    } catch (err) {
        console.error("Error:", err);
        return [];
    }
}

export const saveBillToDocDeliveryReq = (payload: any, billToCode: any) => async (dispatch: any) => {
    try {
        const res = await POST(
            `/customers/billto/${billToCode}/req-doc-config`,
            payload,
        );
        if (res) return res;
        return null;
    } catch (err) {
        console.error("saveBillToDocDeliveryReq error:", err);
        return null;
    }
};

export const getBillToDocDeliveryReq = (billToCode: any) => async (dispatch: any) => {
    try {
        const res = await GET(`/customers/billto/${billToCode}/req-doc-config`);
        if (res) return res;
        return null;
    } catch (err) {
        console.error("getBillToDocDeliveryReq error:", err);
        return null;
    }
};

// Delete single EMAIL row
export const deleteEmailDocRowReq = (billToCode: any, ruleId: any) => async (dispatch: any) => {
    try {
        const res = await DELETE(`/customers/billto/${billToCode}/req-doc-config/${ruleId}`);
        return res;
    } catch (err) {
        console.error("deleteEmailDocRowReq error:", err);
        return null;
    }
};

// Delete single SFTP/FTP row
export const deleteSftpDocRowReq = (billToCode: any, deliveryId: any, ruleId: any) => async (dispatch: any) => {
    try {
        const res = await DELETE(`/customers/billto/${billToCode}/req-doc-config/delivery/${deliveryId}/rule/${ruleId}`);
        return res;
    } catch (err) {
        console.error("deleteSftpDocRowReq error:", err);
        return null;
    }
};

// Delete ALL delivery config
export const deleteAllDocDeliveryReq = (billToCode: any) => async (dispatch: any) => {
    try {
        const res = await DELETE(`/customers/billto/${billToCode}/req-doc-config`);
        return res;
    } catch (err) {
        console.error("deleteAllDocDeliveryReq error:", err);
        return null;
    }
};

// GET invoice config
export const getInvoiceConfig = (code: any) => async (dispatch: any) => {
    try {
        const res = await GET(`/customers/${code}/invoice-config`);
        if (res?.success && res?.data) {  
            return res.data;
        }
        return null;
    } catch (err) {
        console.error("getInvoiceConfig error:", err);
        return null;
    }
};

// POST — handles both create and update
export const saveInvoiceConfig = (payload: any, code: any) => async (dispatch: any) => {
    try {
        const res = await POST(`/customers/${code}/invoice-config`, payload);
        return res;
    } catch (err) {
        console.error("saveInvoiceConfig error:", err);
        return null;
    }
};

// DELETE entire invoice config
export const deleteInvoiceConfig = (code: any) => async (dispatch: any) => {
    try {
        const res = await DELETE(`/customers/${code}/invoice-config`);
        return res;
    } catch (err) {
        console.error("deleteInvoiceConfig error:", err);
        return null;
    }
};

export const getFileNameFormatOrderFields = () => async (_dispatch: any) => {
    try {
        const res = await GET(`/customers/file-name-format/order-fields`);
        if (res?.success && Array.isArray(res?.data)) {
            return res.data;
        }
        return [];
    } catch (err) {
        console.error("getFileNameFormatOrderFields error:", err);
        return [];
    }
};

export const getBillToFileNameFormatConfig = (
    billToCode: any,
    deliveryMethodCode?: string,
) => async (_dispatch: any) => {
    try {
        const suffix = deliveryMethodCode
            ? `?deliveryMethodCode=${encodeURIComponent(deliveryMethodCode)}`
            : "";

        const res = await GET(
            `/customers/billto/${billToCode}/file-name-format-config${suffix}`,
        );

        if (res?.success && res?.data) {
            return res.data;
        }

        return { EMAIL: {}, FTP: {}, SFTP: {} };
    } catch (err) {
        console.error("getBillToFileNameFormatConfig error:", err);
        return { EMAIL: {}, FTP: {}, SFTP: {} };
    }
};

// ─── File Name Format Config API actions ─────────────────────────────────────

export const listFileNameFormatConfigs = (
    deliveryMethodCode: string,
    billToCode?: string,
) => async (_dispatch: any) => {
    try {
        let qs = `?deliveryMethodCode=${encodeURIComponent(deliveryMethodCode)}`;
        if (billToCode) qs += `&billToCode=${encodeURIComponent(billToCode)}`;
        const res = await GET(`/customers/file-name-format-configs${qs}`);
        if (res?.success) return res.data ?? [];
        return [];
    } catch (err) {
        console.error("listFileNameFormatConfigs error:", err);
        return [];
    }
};

export const createFileNameFormatConfig = (payload: {
    deliveryMethodCode: string;
    docTypeCode: number;
    billToCode?: string;
    fileFormat?: string;
    fileNameFormat?: string;
    incomingDirectory?: string;
}) => async (_dispatch: any) => {
    try {
        const res = await POST(`/customers/file-name-format-configs`, payload);
        return res;
    } catch (err) {
        console.error("createFileNameFormatConfig error:", err);
        return null;
    }
};

export const updateFileNameFormatConfig = (
    id: number,
    payload: {
        deliveryMethodCode: string;
        docTypeCode: number;
        fileFormat?: string;
        fileNameFormat?: string;
        incomingDirectory?: string;
    },
) => async (_dispatch: any) => {
    try {
        const res = await PUT(`/customers/file-name-format-configs/${id}`, payload);
        return res;
    } catch (err) {
        console.error("updateFileNameFormatConfig error:", err);
        return null;
    }
};

export const deleteFileNameFormatConfigReq = (id: number) => async (_dispatch: any) => {
    try {
        const res = await DELETE(`/customers/file-name-format-configs/${id}`);
        return res;
    } catch (err) {
        console.error("deleteFileNameFormatConfigReq error:", err);
        return null;
    }
};

export const lookupFileNameFormatConfig = (
    deliveryMethodCode: string,
    docTypeCode: number,
    billToCode?: string,
) => async (_dispatch: any) => {
    try {
        let qs = `?deliveryMethodCode=${encodeURIComponent(deliveryMethodCode)}&docTypeCode=${docTypeCode}`;
        if (billToCode) qs += `&billToCode=${encodeURIComponent(billToCode)}`;
        const res = await GET(`/customers/file-name-format-configs/lookup${qs}`);
        if (res?.success) return res.data ?? null;
        return null;
    } catch (err) {
        console.error("lookupFileNameFormatConfig error:", err);
        return null;
    }
};

export const deleteOrderByContact = (seq: any, code: any) => {
    return async (dispatch: Dispatch) => {
        const res = await deleteOrderByContactReq(seq, code);
        dispatch(setMaintenance(res));

        return res;
    }
}

export const deleteOrderByContactReq = async (seq: any, code: any) => {
    try {
        let res = await DELETE(`/contacts/customers/${code}/delete/${seq}`);
        return res;
    } catch (err) {
        return [];
    }
}

export const getRelatedOrders = (LocationNumber: any, code: any, page: any, pageSize: any) => {
    return async (dispatch: Dispatch) => {
        const res = await getRelatedOrdersReq(LocationNumber, code, page, pageSize);
        dispatch(setMaintenance(res));
        return res;
    }
}

export const getRelatedOrdersReq = async (
    locationNumber: number,
    code: string,
    page: number,
    pageSize: number
) => {
    try {
        const url = `/customers/${code}/orderbys?page=${page + 1}&size=${pageSize}`;
        // const url = `/customers/code/${code}`;
        return await GET(url);
    } catch (err) {
        console.error(err);
        return { data: [], totalCount: 0 };
    }
};

export const getHistory = (LocationNumber: any, code: any, page: any, pageSize: any) => {
    return async (dispatch: Dispatch) => {
        const res = await getHistoryReq(LocationNumber, code, page, pageSize);
        dispatch(setMaintenance(res));
        return res;
    }
}

export const getHistoryReq = async (
    locationNumber: number,
    code: string,
    page: number,
    pageSize: number
) => {
    try {
        console.log("called history")
        const url = `/history/BILLTO/${code}?page=${page}&size=${pageSize}`;
        // const url = `/history/CUSTOMER/${code}`;
        return await GET(url);
    } catch (err) {
        console.error(err);
        return { data: [], totalCount: 15 };
    }
};

export const deleteBillToContact = (seq: any) => {
    return async (dispatch: Dispatch) => {
        const res = await deleteBillToContactReq(seq);
        dispatch(setMaintenance(res));

        return res;
    }
}

export const deleteBillToContactReq = async (seq: any) => {
    try {
        let res = await DELETE(`/contacts/800/${seq}`);
        return res;
    } catch (err) {
        return [];
    }
}


export const getBillToContact = (code: any) => {
    return async (dispatch: Dispatch) => {
        const res = await getBillToContactReq(code);
        dispatch(setMaintenance(res));

        return res;
    }
}

export const getBillToContactReq = async (code: any) => {
    try {
        let res = await GET(`/contacts/list/code/${code}`);
        return res;
    } catch (err) {
        return [];
    }
}
